// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionTitle_section-title__L2gaC {
  color: var(--explore-color);
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--explore-color);
}
.SectionTitle_section-title__L2gaC.SectionTitle_collapse__ev20U {
  cursor: pointer;
}
.SectionTitle_section-title__L2gaC .SectionTitle_collapse-icon__WiOF0 {
  margin-left: auto;
}
.SectionTitle_section-title__L2gaC .SectionTitle_collapse-icon__WiOF0 svg {
  transform: rotate(90deg);
  transition: all 0.2s ease;
}
.SectionTitle_section-title__L2gaC .SectionTitle_collapse-icon__WiOF0.SectionTitle_open__cUkDe svg {
  transform: rotate(-90deg);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SectionTitle/SectionTitle.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,6CAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AACI;EACE,wBAAA;EACA,yBAAA;AACN;AAGM;EACE,yBAAA;AADR","sourcesContent":[".section-title {\n  color: var(--explore-color);\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--explore-color);\n\n  &.collapse {\n    cursor: pointer;\n  }\n\n  .collapse-icon {\n    margin-left: auto;\n    svg {\n      transform: rotate(90deg);\n      transition: all 0.2s ease;\n    }\n\n    &.open {\n      svg {\n        transform: rotate(-90deg);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section-title": `SectionTitle_section-title__L2gaC`,
	"collapse": `SectionTitle_collapse__ev20U`,
	"collapse-icon": `SectionTitle_collapse-icon__WiOF0`,
	"open": `SectionTitle_open__cUkDe`
};
export default ___CSS_LOADER_EXPORT___;
